import { IconButton, Tooltip } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import { getUserId } from "src/login/selector";
import { State } from "src/state";
import { v4 as uuid } from "uuid";
import { TrashIcon } from "../../../documentUpload/TrashIcon";
import { isRequesting } from "../../../requestProgress/helpers";
import { actions } from "../../../requestProgress/reducer";
import { getRequestProgress } from "../../../requestProgress/selector";
import { QuiqIcon } from "../../../shared/QuiqIcon";
import { AccountPresenterKind } from "../../model/presenter/types";
import { SaveTagActionType, tagAccount } from "../../model/spread/actions";
import { disableTagMode, setActiveTagArea } from "./actions";
import { SaveIcon } from "./SaveIcon";
import { getActiveTagArea, getTagAreas, getTagConfig } from "./selector";
import TagCell from "./TagCell";
import "./TagRow.scss";
import { TagAccount, TagArea, TagConfig } from "./types";

interface TagRowProps {
  setActiveTagArea: typeof setActiveTagArea;
  account: AccountPresenterKind<"VALUE">;
  hierarchyLevel: number;
  tagConfig: TagConfig;
  tagAreas: TagArea[];
  disableTagMode: typeof disableTagMode;
  tagAccount: SaveTagActionType;
}

const TagRow = (props: TagRowProps) => {
  const { account, hierarchyLevel } = props;

  const buildAccount = () => {
    const result = {} as TagAccount;

    const labelArea = props.tagAreas.find(
      area => area.areaId === "label"
    ) as TagArea;
    const period1Area = props.tagAreas.find(area => area.areaId === "period1");
    const period2Area = props.tagAreas.find(area => area.areaId === "period2");
    const { groupId, parentNodeId, period1, period2 } = props.tagConfig;

    result.groupId = groupId;
    result.parentNodeId = parentNodeId;
    result.labelRect = { id: uuid(), ...labelArea, period: "" };
    result.accountsForPeriod = [];

    if (period1Area) {
      result.accountsForPeriod.push({
        id: uuid(),
        ...period1Area,
        period: period1
      });
    }

    if (props.tagConfig.periodCount === 2 && period2Area) {
      result.accountsForPeriod.push({
        id: uuid(),
        ...period2Area,
        period: period2
      });
    }

    return result;
  };

  const isSelected = areaId => {
    return areaId === props.tagConfig.activeAreaId;
  };

  const handleOnClick = areaId => event => {
    if (areaId !== props.tagConfig.activeAreaId) {
      props.setActiveTagArea(areaId);
    } else {
      props.setActiveTagArea(null);
    }
  };

  const getOcr = areaId => {
    const objArr = props.tagAreas.filter(area => area.areaId === areaId);

    return objArr.length ? objArr[0].value : "";
  };

  const onClose = () => {
    props.disableTagMode();
  };

  const onSave = () => {
    const acc = buildAccount();
    props.tagAccount(acc).then(() => {
      props.disableTagMode();
    });
  };

  const isSaveDisabled = () => {
    const labelArea = props.tagAreas.find(area => area.areaId === "label");

    if (!labelArea) {
      return true;
    }

    return !props.tagAreas.find(
      area => area.areaId === "period1" || area.areaId === "period2"
    );
  };

  return (
    <div
      className={`AccountRow__container AccountRow__container--hidden AccountRow__container--period-${account.periodValues.length} TagRow__hover--disabled`}
    >
      <div
        className={`AccountRow__hover-container AccountRow__hover-container--level-${hierarchyLevel}`}
      >
        <div className="AccountRow__expander AccountRow__expander--hidden" />
        <TagCell
          areaId="label"
          getOcr={getOcr}
          isSelected={isSelected}
          handleOnClick={handleOnClick}
          classes="AccountRow__name AccountRow__name--hidden"
        />
        {account.periodValues.map((periodValue, index) => {
          return (
            <div className="AccountRow__text--container" key={index}>
              <TagCell
                areaId={`period${index + 1}`}
                getOcr={getOcr}
                isSelected={isSelected}
                handleOnClick={handleOnClick}
                classes={`AccountRow__value AccountRow__value--hidden AccountRow__value--period-${index +
                  1} AccountRow__value--with-icon`}
              />
            </div>
          );
        })}
        <div className="AccountRow__tag">
          <Tooltip
            classes={{ tooltip: "ToolTip-container" }}
            title={"Remove Account"}
            placement="top"
          >
            <IconButton
              className="AccountRow__button"
              children={<TrashIcon />}
              color={"inherit"}
              onClick={onClose}
            />
          </Tooltip>
          <Tooltip
            classes={{ tooltip: "ToolTip-container" }}
            title={"Save Account"}
            placement="top"
          >
            <QuiqIcon
              className="AccountRow__button"
              children={<SaveIcon />}
              color={"inherit"}
              onClick={onSave}
              isDisabled={isSaveDisabled()}
              isLoading={isRequesting(actions.tagAccount)}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: State) => ({
  userId: getUserId(state),
  tagAreas: getTagAreas(state),
  areaId: getActiveTagArea(state),
  tagConfig: getTagConfig(state),
  requestProgress: getRequestProgress(state)
});

export default connect(
  mapStateToProps,
  {
    setActiveTagArea,
    disableTagMode,
    tagAccount: tagAccount.action
  }
)(TagRow);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/Tag/TagRow.tsx